import { render } from "./InternationalTradeRussia.vue?vue&type=template&id=0e590e67&scoped=true"
import script from "./InternationalTradeRussia.vue?vue&type=script&lang=js"
export * from "./InternationalTradeRussia.vue?vue&type=script&lang=js"

import "./InternationalTradeRussia.vue?vue&type=style&index=0&id=0e590e67&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e590e67"]])

export default __exports__